<template>
  <transition name="fade">
    <div class="swatch" style="position:absolute;">
      <ul>
        <li v-for="color in colors">
          <button @click="updateValue(color.id)"><i :class="['color-swatch-item', 'color-'+color.id]"></i> {{ color.name }}</button>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>

  export default {
    name: 'annotatorColorSwatch',
    props: {
      value: {}
    },
    data () {
      return {
        colors: this.$store.getAll('annotationColors'),
        innerValue: this.value
      }
    },
    methods: {
      updateValue (val) {
        this.$emit('input', val)
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  .swatch {
    @include transition();
    background:#fff; width:22rem; padding:1rem; border:1px solid $color-gray; box-shadow:0 1px 3px 0 rgba($color-black, .1); position:absolute; z-index:99; text-transform:none;
    @media print {
      display:none !important;
    }
    &:before {
      @include position(absolute, calc(-.75rem - 1px) null null 1.5rem);
      @include size(1.5rem);
      display:block; background:#fff; border:solid $color-gray; border-width:1px 1px 0 0; content:''; transform:rotate(-45deg);
    }
    &.fade {
      &-enter-active, &-leave-active {
        @include transition(opacity);
      }
      &-enter, &-leave-to {
        opacity:0;
      }
    }
  }

  ul {
    @include list-style-reset;
    display:flex; flex-wrap:wrap;
  }

  li {
    display:flex; align-items:center; width:50%;
  }

  i {
    margin-right:.25rem; position:relative; top:-1px;
  }

  button {
    @include transition();
    @include font-size(xsmall);
    width:100%; text-align:left; padding:.5rem 1rem; border-radius:3px;
    &:hover, &:focus {
      color:$color-primary; background-color:$color-gray-lightest;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Annotator/swatch.vue